import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import for table support
import * as XLSX from 'xlsx'; // Import xlsx for Excel export
import axios from 'axios';

const TodayKarigarDeliveryList = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      const todayDate = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
      const response = await axios.get(`http://147.79.71.207:3125/api/orders/karigar-date?date=${todayDate}`);
      if (response.data.status === 1) {
        setOrders(response.data.data);
        setFilteredOrders(response.data.data); // Set initial filtered orders
      } else {
        setError('No orders found for today.');
      }
    } catch (error) {
      setError('Error fetching orders.');
      console.error('API Error:', error);
    }
    setLoading(false);
  };

  // Handle Search
  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    const filtered = orders.filter((order) =>
      order.karigar_name.toLowerCase().includes(term.toLowerCase()) ||
      order.customer_name.toLowerCase().includes(term.toLowerCase()) ||
      order.subcategory_name.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredOrders(filtered);
  };

  // Export to PDF
const handleExportPDF = () => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Karigar Delivery List', 14, 10); // Title at top of PDF

  // Prepare table data for PDF
  const tableData = filteredOrders.map((order) => [
    order.id,
    order.karigar_name || 'N/A',
    order.customer_name || 'N/A',
    order.staff_name || 'N/A',
    order.subcategory_name || 'N/A',
    order.size || 'N/A',
    order.mlt || 'N/A',
    order.weight || 'N/A',
    order.pcs || 'N/A',
    order.rodiem || 'N/A',
    order.huid_hallmark || 'N/A',
    new Date(order.delivery_date).toLocaleDateString() || 'N/A',
    order.images && order.images.length > 0 ? (
      <img
        src={`http://147.79.71.207:3125${JSON.parse(order.images)[0]}`}
        alt="Order"
        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
      />
    ) : 'N/A',
  ]);

  const headers = [
    'ID',
    'Karigar Name',
    'Customer',
    'Staff',
    'Subcategory',
    'Size',
    'MLT',
    'Weight',
    'PCS',
    'Rodiem',
    'Hallmark',
    'Delivery Date',
    'Image',
  ];

  // Set the column widths dynamically based on content
  const columnWidths = [
    20, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30
  ];

  // Create the table
  doc.autoTable({
    head: [headers],
    body: tableData,
    startY: 20,
    theme: 'grid',
    headStyles: {
      fillColor: [22, 160, 133],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      halign: 'center',
    },
    bodyStyles: {
      halign: 'center',
      valign: 'middle',
    },
    columnStyles: columnWidths.reduce((acc, width, index) => {
      acc[index] = { cellWidth: width };
      return acc;
    }, {}),
    margin: { top: 20 },
    didDrawPage: function (data) {
      doc.setFontSize(10);
      doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
    },
    pageBreak: 'auto', // Ensure that the table content will break properly across multiple pages
  });

  doc.save('karigar_delivery_list.pdf');
};

  // Export to Excel
  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredOrders.map((order) => ({
        ID: order.id || 'N/A',
        Karigar: order.karigar_name || 'N/A',
        Customer: order.customer_name || 'N/A',
        Staff: order.staff_name || 'N/A',
        Subcategory: order.subcategory_name || 'N/A',
        Size: order.size || 'N/A',
        MLT: order.mlt || 'N/A',
        Weight: order.weight || 'N/A',
        PCS: order.pcs || 'N/A',
        Rodiem: order.rodiem || 'N/A',
        Hallmark: order.huid_hallmark || 'N/A',
        DeliveryDate: new Date(order.delivery_date).toLocaleDateString() || 'N/A',
        Image: order.images ? `${BASE_URL}${JSON.parse(order.images)[0]}` : 'N/A',
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Karigar Delivery List');

    XLSX.writeFile(workbook, 'karigar_delivery_list.xlsx');
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Today Karigar Delivery List</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-6"></div>
                  <div className="col-md-6 text-end">
                    {/* <button className="btn btn-primary" onClick={() => navigate('/AddOrder')}>Add Order</button> */}
                    <button className="btn btn-secondary ms-2" onClick={handleExportPDF}>Export to PDF</button>
                    {/* <button className="btn btn-secondary ms-2" onClick={handleExportExcel}>Export to Excel</button> */}
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="searchTerm" className="form-label">Search by Karigar, Customer, or Subcategory</label>
                  <input
                    type="text"
                    id="searchTerm"
                    className="form-control"
                    placeholder="Search by Karigar, Customer, or Subcategory"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
                <div className="table-responsive">
                  <table className="table table-lg">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Karigar Name</th>
                        <th>Customer</th>
                        <th>Staff</th>
                        <th>Subcategory</th>
                        <th>Size</th>
                        <th>MLT</th>
                        <th>Weight</th>
                        <th>PCS</th>
                        <th>Rodiem</th>
                        <th>Hallmark</th>
                        <th>Delivery Date</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="13" className="text-center">Loading...</td>
                        </tr>
                      ) : error ? (
                        <tr>
                          <td colSpan="13" className="text-center text-danger">{error}</td>
                        </tr>
                      ) : currentOrders.length > 0 ? (
                        currentOrders.map((order) => (
                          <tr key={order.id}>
                            <td>{order.id}</td>
                            <td>{order.karigar_name || 'N/A'}</td>
                            <td>{order.customer_name || 'N/A'}</td>
                            <td>{order.staff_name || 'N/A'}</td>
                            <td>{order.subcategory_name || 'N/A'}</td>
                            <td>{order.size || 'N/A'}</td>
                            <td>{order.mlt || 'N/A'}</td>
                            <td>{order.weight || 'N/A'}</td>
                            <td>{order.pcs || 'N/A'}</td>
                            <td>{order.rodiem || 'N/A'}</td>
                            <td>{order.huid_hallmark || 'N/A'}</td>
                            <td>{new Date(order.delivery_date).toLocaleDateString()}</td>
                            <td>
                              {order.images ? (
                                <img
                                  src={`http://147.79.71.207:3125${JSON.parse(order.images)[0]}`}
                                  alt="Order"
                                  style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                />
                              ) : 'N/A'}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="13" className="text-center">No orders found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="pagination">
                  {/* Add pagination logic */}
                  <button
                    className="btn btn-link"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-link"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={indexOfLastItem >= filteredOrders.length}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TodayKarigarDeliveryList;
